export default __webpack_public_path__ + "2516825997f67db07bb5bd112b5b846d.svg";